import { call, put, takeLatest } from 'redux-saga/effects'

import { sagaGet } from '../../fetch/index'
import { sagaLogoutUnauthorizedUser } from '../logout'
import { sagaHandleError, BadResponseError } from '../../helpers'
import {
  FETCH_BRANDS_REPORT_REQUEST,
  FETCH_BRANDS_REPORT_SUCCESS,
} from '../../stores/report'
import { API_BRANDS_REPORT } from '../../urls'

const requestConfig = { headers: { Accept: 'application/json' } }

// format API request to use querysStrings
const InsertQueryStrings = (url, start, end) =>
  `${url}?createdGte=${start}&createdLte=${end}`

export function* fetchReport({ payload }) {
  const { startDate, endDate } = payload

  try {
    const response = yield call(
      sagaGet,
      InsertQueryStrings(API_BRANDS_REPORT, startDate, endDate),
      requestConfig
    )

    if (response.status === 401 || response.status === 403)
      return yield call(sagaLogoutUnauthorizedUser)
    if (response.status === 404) return
    if (response.status !== 200) throw new BadResponseError(response)

    const data = yield response.json()

    const spans = yield data.spans.map(span => {
      const clickthroughrate = ((span.clicks / span.votes) * 100 || 0).toFixed(
        2
      )
      const ffclickthroughrate = (
        (span.clicks / span.impressions) * 100 || 0
      ).toFixed(2)
      const engagementrate = (
        (span.votes / span.impressions) * 100 || 0
      ).toFixed(2)
      return {
        ...span,
        engagementrate,
        clickthroughrate,
        ffclickthroughrate,
      }
    })

    const polls = yield data.polls.map(poll => {
      const clickthroughrate = ((poll.clicks / poll.votes) * 100 || 0).toFixed(
        2
      )
      const ffclickthroughrate = (
        (poll.clicks / poll.impressions) * 100 || 0
      ).toFixed(2)
      const engagementrate = (
        (poll.votes / poll.impressions) * 100 || 0
      ).toFixed(2)
      return {
        ...poll,
        engagementrate,
        clickthroughrate,
        ffclickthroughrate,
      }
    })

    const parsedData = { ...data, spans, polls }

    yield put({ type: FETCH_BRANDS_REPORT_SUCCESS, payload: parsedData })
  } catch (err) {
    yield call(sagaHandleError, err)
  }
}

function* ReportSaga() {
  yield takeLatest(FETCH_BRANDS_REPORT_REQUEST, fetchReport)
}

export default ReportSaga



// WEBPACK FOOTER //
// ./src/sagas/report/fetchBrandReports.js